import { render, staticRenderFns } from "./MenuRow.vue?vue&type=template&id=7369947d&lang=pug&"
import script from "./MenuRow.vue?vue&type=script&lang=js&"
export * from "./MenuRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports